<!-- We dont need a template as the template is in the cshtml file -->

<script lang="ts">
import { defineComponent } from 'vue'
import ServicesFinder from './services-finder.vue'

export default defineComponent({
    components: {
        ServicesFinder
    }
})
</script>
